import { Component, Input, OnInit } from '@angular/core';
import { CookieService } from '@global/cookie-banner/services/cookie/cookie.service';

@Component({
  selector: 'app-cookie-banner-display',
  templateUrl: './cookie-banner-display.component.html',
})
export class CookieBannerDisplayComponent implements OnInit {
  @Input() cookieUrl: string;

  cookieValue = 'cb-enabled';
  isShowCookie: boolean;

  constructor(private cookieService: CookieService) {}

  onCookieAccepted() {
    this.cookieService.setCookie(this.cookieValue, 'accepted', 365);
    this.isShowCookie = false;
  }

  ngOnInit() {
    this.isShowCookie = !this.cookieService.getCookie(this.cookieValue);
  }
}
